// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"415":"d33535571b6c2ae08520","888":"3ca3b8b46c0530011858"}[chunkId] + ".css";
};